import { PriceRender } from 'components/DisplayPrice';
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const PriceRangeSlider = ({ minValue = 0, maxValue = 100, value = 0, setValue = () => {}, step = 0.1 }) => {
  const [isDragging, setIsDragging] = useState(false);
  const sliderRef = useRef(null);
  const { t } = useTranslation();

  const getPercentage = (value) => {
    return ((value - minValue) / (maxValue - minValue)) * 100;
  };

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !sliderRef.current) return;

    const slider = sliderRef.current;
    const rect = slider.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const x = clientX - rect.left;

    const percentage = Math.min(Math.max(0, x / rect.width), 1);
    // const newValue =  parseFloat((minValue + percentage * (maxValue - minValue)).toFixed(2));
    const rawValue = minValue + percentage * (maxValue - minValue);
    let newValue = parseFloat(Math.round(rawValue / step) * step).toFixed(2); 
    if(newValue > maxValue) {
      newValue = maxValue;
    }
    if(newValue < minValue) {
      newValue = minValue;
    }
    setValue(+newValue);
  };


  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleMouseMove);
      document.addEventListener('touchend', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleMouseMove);
      document.removeEventListener('touchend', handleMouseUp);
    };
  }, [isDragging]);

  return (
    <div className="w-full mx-auto px-4 select-none" style={{paddingTop: "54px"}}>
      <div
        ref={sliderRef}
        className="relative w-full rounded-full cursor-pointer"
        style={{ height: '12px' }}
        onMouseDown={handleMouseDown}
        onTouchStart={handleMouseDown}
      >
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden rounded-full">
          <div
            className="absolute top-0 left-0 w-full h-full"
            style={{
              clipPath: 'polygon(-100px 100%, 100% 10.75%, 100% 100%, 0% 100%)',
              background: '#F3F4F6',
            }}
          />
        </div>

        <div
          className="absolute top-0 left-0 h-full rounded-full overflow-hidden"
          style={{ width: `${getPercentage(value)}%`, backgroundColor: 'transparent' }}
        >
          <div
            className="absolute top-0 left-0 w-full h-full"
            style={{
              clipPath: 'polygon(-100px 100%, 100% 10.75%, 100% 100%, 0% 100%)',
              backgroundImage:
                'linear-gradient(to right, var(--light-brand-base-primary), var(--brand-base-primary))',
            }}
          />
        </div>

        <div
          className="absolute w-6 h-6 bg-brand-base-primary rounded-full shadow-md flex items-center justify-center cursor-grab active:cursor-grabbing"
          style={{
            left: `calc(${getPercentage(value)}% - 12px)`,
            top: '-6px',
          }}
          onMouseDown={handleMouseDown}
          onTouchStart={handleMouseDown}
        >
          <div
            className="absolute bg-brand-base-primary text-white px-2 py-1 rounded-24x text-sm whitespace-nowrap transform -translate-x-1/2 left-1/2 opacity-100"
            style={{ top: '-35px' }}
          >
            <PriceRender price={+value} className="text-16x leading-none"  currencySymbolClassName="CURRENT"/>
            <div
              style={{
                position: 'absolute',
                bottom: '-6px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: 0,
                height: 0,
                borderLeft: '6px solid transparent',
                borderRight: '6px solid transparent',
                borderTop: '6px solid var(--brand-base-primary)',
              }}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-between mt-4 text-16x font-semibold text-dark-blue-900">
        <PriceRender price={+minValue} className="text-16x leading-none"  currencySymbolClassName="CURRENT"/>
        <PriceRender price={+maxValue} className="text-16x leading-none"  currencySymbolClassName="CURRENT"/>
      </div>
    </div>
  );
};

export default PriceRangeSlider;
